import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { TabBar, TabItem } from '../components';

const LandscapeAboutBaseTemplate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  return (
    <div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={location.pathname}
      >
        <TabItem title="Participant" id={`/landscapes/edit/${id}/about`} />
        <TabItem
          title="Landscape"
          id={`/landscapes/edit/${id}/about/landscape`}
        />
        <TabItem
          title="Committed buyers"
          id={`/landscapes/edit/${id}/about/committed-buyers`}
        />
        <TabItem
          title="ContactPersons"
          id={`/landscapes/edit/${id}/about/contact-person`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeAboutBaseTemplate;
